import React, { useState, useEffect, useCallback } from "react";
import Navmenu from "../Navmenu";
import Appbar from "../Appbar";
import "../../style/ArticleMain.scss";
import { Row, Col, List } from "bootstrap-4-react";
import Footer from "../Footer";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import { Bookmark, BookmarkBorder } from "@material-ui/icons";
import ShareNews from "../../govt-circular-gr/ShareNews";
import axios from "axios";
import { apiURL, getID } from "../../utils";
import SanitizedHTML from "react-sanitized-html";
import Moment from "moment";
import Meta from "../../meta/Meta";
import Rating from "../Rating";
import { IconButton, Container } from "@material-ui/core";
import Comments from "./Comments";
import OtherArticle from "./OtherArticle";
import NoDataFound from "../../common/NoDataFound";

const styles = (theme) => ({
  root: {
    maxWidth: "100%",
  },
});

const SingleArticle = (props) => {
  const { match, history, location } = props;

  const [articleData, setArticleData] = useState({});
  const [isBookmark, setIsBookmark] = useState(false);
  const [loading, setLoading] = useState(true);
  const [noResult, setNoResult] = useState(false);
  const [categoryId, setCategoryId] = useState("");

  const articleListData = useCallback(() => {
    const headers = { "Content-type": "application/json" };

    const body = {
      id: match.params.articleId,
      category_id: "",
      user_id: getID(),
    };

    axios
      .post(
        apiURL("article/get_all_article?per_page=1&page=1"),
        body,
        { headers }
      )
      .then((response) => {
        const resultData = response.data;

        if (
          (resultData.status === true || resultData.status === 1) &&
          resultData.result &&
          resultData.result.length > 0
        ) {
          const data = resultData.result[0];
          setArticleData(data);
          setIsBookmark(data.is_bookmark || false);
          setCategoryId(data.fldi_category_id);
          setNoResult(false);
        } else {
          setArticleData({});
          setNoResult(true);
        }
        setLoading(false);
      })
      .catch(() => {
        setNoResult(true);
        setLoading(false);
      });
  }, [match.params.articleId]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    articleListData();
  }, [articleListData]);

  const handleAddBookMark = (id) => {
    axios.post(apiURL("bookmark/addBookmark"), {
      content_id: id,
      content_type: "articles",
      user_id: getID(),
    }).then(() => setIsBookmark(true));
  };

  const handleRemoveBookMark = (id) => {
    axios.post(apiURL("bookmark/removeBookmark"), {
      content_id: id,
      content_type: "articles",
      user_id: getID(),
    }).then(() => setIsBookmark(false));
  };

  const handleBack = () => {
    if (categoryId === "1") history.push("/academic-essays");
    else if (categoryId === "2") history.push("/success-stories");
    else if (categoryId === "3") history.push("/interviews");
    else if (categoryId === "4") history.push("/book-recommendations");
    else if (categoryId === "5") history.push("/self-development");
    else history.goBack();
  };

  return (
    <>
      <Meta
        tableName="article"
        objectId={match.params.articleId}
        forPage="inner_page"
      />

      <Appbar />
      <div className="sticky-top sign-light">
        <Navmenu />
      </div>

      <section className="BannerBox articleBanner" id="article-smooth-scroll">
        <div className="sixteen-nine" />
      </section>

      <section className="articleSingle">
        <Container maxWidth="lg">
          {loading ? (
            <div className="text-center py-5">Loading...</div>
          ) : noResult ? (
            <NoDataFound message="This article is no longer available." />
          ) : (
            <>
              <h1>{articleData.fldv_title}</h1>

              <Row>
                <Col sm="12" className="fixed-content">
                  <SanitizedHTML
                    allowedAttributes={false}
                    allowedTags={false}
                    html={articleData.fldt_description}
                  />
                   {/*updated html */}
                  
                </Col>
              </Row>
            </>
          )}
        </Container>
      </section>
      {!loading && !noResult && (
        <section className="articleAction">
          <Container className="mt-5" maxWidth="lg">
            <div className="actionArtSingle">
              {isBookmark ? (
                <IconButton
                  className="bookmark"
                  style={{
                    color: "orange",
                    border: "3px solid #064e89",
                  }}
                  onClick={() => handleRemoveBookMark(articleData.fldi_id)}
                >
                  <Bookmark />
                </IconButton>
              ) : (
                <IconButton
                  className="bookmark"
                  style={{
                    color: "#064e89",
                    border: "3px solid #064e89",
                  }}
                  onClick={() => handleAddBookMark(articleData.fldi_id)}
                >
                  <BookmarkBorder />
                </IconButton>
              )}

              <div className="rating">
                <Rating
                  blogId={articleData.fldi_id}
                  userId={getID()}
                  rating={articleData.rating}
                  color="gold"
                />
              </div>
            </div>

            <div className="share">
              <ShareNews
                blogId={articleData.fldi_id}
                shareUrl={window.location.href}
                title={articleData.fldv_title}
                date={Moment(articleData.fldv_select_date).format(
                  "dddd, D MMM, YYYY"
                )}
                time={Moment(articleData.fldv_from_time).format("hh:mmA")}
              />
            </div>
          </Container>
        </section>
        
      )}
      {!loading && !noResult && articleData.fldi_id && (
        <Comments articleId={articleData.fldi_id} />
      )}
      {!loading && (
        <OtherArticle
          category_id={categoryId || location?.state?.category_id || ""}
          id={articleData?.fldi_id || ""}
          history={history}
          category_name={location?.state?.category}
        />
      )}
      {!loading && (
        <Container>
          <div className="articleBack">
            <Button onClick={handleBack}>Back</Button>
          </div>
        </Container>
      )}

      <Footer />
    </>
  );
};

export default withStyles(styles)(SingleArticle);
